<template>
  <div class="cut-end">
    <div class="cut-end_greeting">
      <div class="greeting-emoji">
        <img
          class="greeting-emoji_image"
          :src="getBrandImageUrl('speed/avatar_emoji.png')"
          alt=""
        />
        <!--        <ion-chip class="greeting-emoji_name">陈一铭</ion-chip>-->
      </div>
      <img class="cheer-emoji" :src="getBrandImageUrl('speed/come_on_emoji.png')" alt="" />
      <div class="statistic flex-row justify-evenly">
        <div>
          <span class="state">【正确】</span><br />
          <span class="num common-color">{{ props.yesNum }}</span>
        </div>
        <div>
          <span class="state">【错误】</span><br />
          <span class="num num-color">{{ props.notNum }}</span>
        </div>
      </div>
      <div v-if="storeData?.courseTypeId === 16" class="end" @click="continuePractise">
        <img :src="getBrandImageUrl('speed/end_exercise_button.png')" alt="" />
        <span class="end-text">回到智阅</span>
      </div>
      <div
        v-if="storeData?.courseTypeId === 3 || storeData?.courseTypeId === 4"
        class="end"
        @click="continuePractise"
      >
        <img :src="getBrandImageUrl('speed/end_exercise_button.png')" alt="" />
        <span class="end-text" style="width: 100%">回到阅读理解</span>
      </div>
      <div
        v-if="
          storeData?.courseTypeId !== 16 &&
          storeData?.courseTypeId !== 3 &&
          storeData?.courseTypeId !== 4
        "
        class="end"
        @click="endTheExercise"
      >
        <img :src="getBrandImageUrl('speed/end_exercise_button.png')" alt="" />
        <img
          class="end-suffix"
          :src="getBrandImageUrl('speed/suffix_end_exercise_button.png')"
          alt=""
        />
        <span class="end-text">结束练习</span>
        <span class="end-suffix-text">并创建抗遗忘</span>
      </div>
      <div
        v-if="
          storeData?.courseTypeId !== 16 &&
          storeData?.courseTypeId !== 3 &&
          storeData?.courseTypeId !== 4
        "
        class="end flex-row justify-center"
      >
        <span class="common-color" @click="continuePractise">继续练习</span>
        <!--        <span v-else :class="{'visibility-hidden': false}" class="common-color" @click="continuePractise">回到智阅</span>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import mqttServer from "@/js/mqtt"
// import http from "@/js/http";
import { defineProps, onBeforeMount, onMounted, ref } from "vue"
import { useRoute } from "vue-router"
import store from "@/js/store"
import { getBrandImageUrl } from "@/js/brandImages"
import pagesQueue from "@/js/pagesQueue"
import { modalController } from "@ionic/vue"

const route = useRoute()
const studentInfo = ref()
const props = defineProps(["yesNum", "notNum", "selectYesIndex", "selectNotIndex"])
const storeData = ref()

const instructData = ref({
  project: "lxll",
  page: "teachIndex",
  module: "CutBoxEndModal",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})

function onMessageReceived(msg: any) {
  if (msg.fn == "continuePractiseSync") {
    continuePractiseSync()
  }
}

// status - 普通练习:common 继续练习:continue 回到智阅:AIReading
let sta: string

// 结束练习并创建抗遗忘 回到首页
async function endTheExercise() {
  const id = storeData.value.courseTypeId || "练习"
  switch (id) {
    case 16: // AI智阅
      sta = "TO_HOME"
      break
    case 3: // 阅读理解
      sta = "TO_HOME"
      break
    case 1: // 单词识记
      sta = "TO_HOME"
      break
    case "练习":
      sta = "TO_HOME"
      break
    default:
      break
  }
  await modalController.dismiss({ status: sta })
}

// 继续练习 回到九宫格
async function continuePractise() {
  mqttServer
    .pushMsg(instructData.value, {
      params: [],
      fn: "continuePractiseSync",
      msgType: "function",
    })
    .then(() => {
      continuePractiseSync()
    })
}

async function continuePractiseSync() {
  const id = storeData.value.courseTypeId || "练习"
  switch (id) {
    case 16: // AI智阅
      sta = "TO_ARTICLE"
      break
    case 3: // 阅读理解
      sta = "TO_ARTICLE"
      break
    case 1: // 单词识记
      sta = "Nine"
      break
    case "练习":
      sta = "Nine"
      break
    default:
      break
  }
  await modalController.dismiss({ status: sta })
  pagesQueue.queuePageChange(sta)
}

// 返回 阅读理解 & AI智阅
// function backToSmartReading() {
//   modalController.dismiss({status: 'TO_ARTICLE'}).catch(e => console.log(e))
// }
//
// function requestGenerateForget(params: any) {
//   return new Promise((resolve: any, reject: any) => {
//     http.post("/forget/generateForget", params).then(async (res: any) => {
//       if (res.data.success) {
//         await alert("21天抗遗忘创建成功。");
//         resolve();
//       } else {
//         reject('')
//       }
//     });
//   });
// }

onBeforeMount(() => {
  storeData.value = store.getAppointment()
})
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.cut-end {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 3vw;
  overflow: visible;

  &_greeting {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 50%;
    font-weight: 600;
    text-align: center;
    letter-spacing: 2px;
    font-size: var(--common-font-size);

    .greeting-emoji {
      position: relative;
      width: 100%;
      height: 100%;

      &_image {
        position: absolute;
        top: 90%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 30%;
      }

      &_name {
        display: inline-block;
        position: absolute;
        top: 125%;
        left: 49%;
        transform: translate(-50%, -50%);
        --background: var(--green-bg-color);
        color: #ffffff;
      }
    }

    .cheer-emoji {
      margin: 20% auto 0;
      height: 3vh;
    }

    .statistic {
      margin: 2vh auto;

      .state {
        color: var(--font-gray);
      }

      .num {
        font-size: var(--font-6);
        line-height: 3.3rem;
      }

      .num-color {
        color: #e64242;
      }
    }

    .end {
      width: 60%;
      margin: 0 auto 3vw;
      position: relative;

      &-suffix {
        position: absolute;
        right: 0;
        top: -39%;
        width: 20vw;
      }

      &-text {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
      }

      &-suffix-text {
        position: absolute;
        right: 7%;
        top: -36%;
        font-size: 2.2vw;
        color: var(--font-golden-color);
      }
    }

    .next-text {
      font-size: 2.5vw;
      color: #742438;
      font-weight: 700;
      line-height: 1.8rem;
      text-align: center;
    }

    .create-forgetfulness {
      font-size: 2.2vw;
      font-weight: 600;
    }
  }
}
</style>
